<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey" />
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(
    /* webpackChunkName: "TopbarSpeedDial" */ "@/components/TopbarSpeedDial"
  );

export default {
  name: "GatewaySpeedDial",
  props: {
    routeName: { type: String, default: "" },
    routeKey: { type: String, default: "" },
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: "Provision new gateway",
          icon: "add",
          colorClass: "primary",
          showForGatewaysScreen: true,
          to: "new",
        },
        {
          label: "Upload CSV of gateways",
          icon: "cloud_upload",
          colorClass: "primary",
          showForGatewaysScreen: true,
          to: "upload",
        },
      ],
    };
  },
  computed: {
    buttons: function () {
      if (this.routeName.startsWith("Gateways")) {
        return this.buttonsConfig.filter((btn) => btn.showForGatewaysScreen);
      } else {
        return this.buttonsConfig;
      }
    },
  },
  components: {
    TopbarSpeedDial,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GatewaySpeedDial.vue